export class Routes {
  // GET
  static getDataBindingPreview = (dataBindingUuid: string): string => `/api/data-binding/${dataBindingUuid}/preview`
  static getDataBindingResource = (dataBindingUuid: string): string => `/api/data-binding/${dataBindingUuid}`

  // POST
  static createDataBinding = (dataBindingUuid: string): string => `/api/data-binding/${dataBindingUuid}`
}
